import { z } from 'zod';

export const LocationMappedCEFieldSchema = z.enum(['PropertyAlert','PropertyOccupant','PropertyPhone','PropertyCell','PropertyEmail','EnforceZone','PropertyStatus','Subdivision','Classification','SubClassification','Flag1','Flag2','Flag3','Flag4']);

export type LocationMappedCEFieldType = `${z.infer<typeof LocationMappedCEFieldSchema>}`

export default LocationMappedCEFieldSchema;
